import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { ParkingCardInfo, Providers, StatusAPIResponse } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CityParkingDiscountByCodeResponse, EntryForDiscount, MasterProviders } from "../../../models/discount.model";
import { CreateTransactionResponse } from "../../../models/ev.model";

@Injectable({
  providedIn: 'root',
})

export class ApiPaymentTransactionService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
  ) { }

      createTransaction(
        token: string,
        site: string,
        entrance: string,
      ): Observable<CreateTransactionResponse> {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
        });
    
        const baseUrl = 'https://ichenparking.com.tw/app_service/api';
        const path = `site/${site}/entrance/${entrance}`;
        const fullUrl = `${baseUrl}/${path}/create_transaction`;
    
        return this.http.get<CreateTransactionResponse>(fullUrl, { headers });
      }


}